import { defineMessages } from "react-intl";

export const messages = defineMessages({
  assignVariantDialogHeader: {
    id: "dTCDMn",
    defaultMessage: "Assign Product",
    description: "dialog header",
  },
  assignProductDialogButton: {
    id: "Nv/toB",
    defaultMessage: "Assign and save",
    description: "button",
  },
  assignProductDialogContent: {
    id: "/TF6BZ",
    defaultMessage: "Search Products",
  },
  assignProductDialogSearch: {
    id: "SHm7ee",
    defaultMessage: "Search by product name, attribute, product type etc...",
  },
});
